module.exports = __webpack_public_path__ + "img/103072.39262f49.png";